const EXCLUDED_TOP_LEVEL_SECTIONS = new Set([
    "display_guidance",
    "analytical_metric_definitions",
    "metric_metadata",
    "priority_framework",
    "activity_classification",
    "schema_completion",
    "data_granularity",
    "data_granularity_note",
]);

const EXCLUDED_FIELD_NAMES = new Set([
    "state_id",
    "district_id",
    "samithi_id",
    "activity_id",
    "designation_id",
    "administrative_level_id",
    "metric_code",
    "group_code",
    "slug",
    "dashboard_path",
    "schema_version",
    "dashboard_type",
    "generated_at",
    "period_id",
    "month_key",
    "month_definition",
    "quarter_definition",
    "activity_status_filter",
    "activity_period_filter",
    "member_level_records_exposed",
    "activity_transaction_records_exposed",
    "drilldown_levels",
]);

export const withoutTechnicalExportFields = (value, path = []) => {
    if (Array.isArray(value)) {
        return value.map((item) => withoutTechnicalExportFields(item, path));
    }

    if (!value || typeof value !== "object" || value instanceof Date) return value;

    return Object.fromEntries(
        Object.entries(value)
            .filter(([key]) => {
                if (path.length === 0 && EXCLUDED_TOP_LEVEL_SECTIONS.has(key)) return false;
                return !EXCLUDED_FIELD_NAMES.has(key);
            })
            .map(([key, child]) => [
                key,
                withoutTechnicalExportFields(child, [...path, key]),
            ]),
    );
};

export const stateSummaryRowsForExcel = (states) =>
    withoutTechnicalExportFields(Array.isArray(states) ? states : [], ["states"]);
